/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IRelationshipManager } from '../../api/domain/application';
import type { ICustomerBase } from '../../api/domain/customer-base';

enum CustomerBaseApiActions {
    UPDATE_CUSTOMER_BASES = 'customer-base-api.update.customer-bases',

    FETCH_CUSTOMER_BASES = 'customer-base-api.fetch.customer-bases',
    FETCH_CUSTOMER_BASES_SUCCESS = 'customer-base-api.fetch.customer-bases.success',
    FETCH_CUSTOMER_BASES_FAILURE = 'customer-base-api.fetch.customer-bases.failure',

    READ_DEFAULT_CUSTOMER_BASE = 'customer-base-api.read.default-customer-base',
    READ_DEFAULT_CUSTOMER_BASE_SUCCESS = 'customer-base-api.read.default-customer-base.success',
    READ_DEFAULT_CUSTOMER_BASE_FAILURE = 'customer-base-api.read.default-customer-base.failure',

    SET_DEFAULT_CUSTOMER_BASE = 'customer-base-api.set.default-customer-base',
    SET_DEFAULT_CUSTOMER_BASE_SUCCESS = 'customer-base-api.set.default-customer-base.success',
    SET_DEFAULT_CUSTOMER_BASE_FAILURE = 'customer-base-api.set.default-customer-base.failure',

    RESOLVE_RM_FOR_CUSTOMER_BASE = 'customer-base-api.set.resolve-rm',
    RESOLVE_RM_FOR_CUSTOMER_BASE_SUCCESS = 'customer-base-api.set.resolve-rm.success',
    RESOLVE_RM_FOR_CUSTOMER_BASE_FAILURE = 'customer-base-api.set.resolve-rm.failure',
}

export const resolveRmForCustomerBase = createAction<ICustomerBase | undefined>(CustomerBaseApiActions.RESOLVE_RM_FOR_CUSTOMER_BASE);
export const resolveRmForCustomerBaseSuccess = createAction<IRelationshipManager>(CustomerBaseApiActions.RESOLVE_RM_FOR_CUSTOMER_BASE_SUCCESS);
export const resolveRmForCustomerBaseFailure = createAction(CustomerBaseApiActions.RESOLVE_RM_FOR_CUSTOMER_BASE_FAILURE);

export const updateCustomerBases = createAction<ICustomerBase[]>(CustomerBaseApiActions.UPDATE_CUSTOMER_BASES);

export const fetchCustomerBases = createAction(CustomerBaseApiActions.FETCH_CUSTOMER_BASES);
export const fetchCustomerBasesSuccess = createAction<ICustomerBase[]>(CustomerBaseApiActions.FETCH_CUSTOMER_BASES_SUCCESS);
export const fetchCustomerBasesFailure = createAction(CustomerBaseApiActions.FETCH_CUSTOMER_BASES_FAILURE);

export const readDefaultCustomerBase = createAction(CustomerBaseApiActions.READ_DEFAULT_CUSTOMER_BASE);
export const readDefaultCustomerBaseSuccess = createAction<ICustomerBase | undefined>(CustomerBaseApiActions.READ_DEFAULT_CUSTOMER_BASE_SUCCESS);
export const readDefaultCustomerBaseFailure = createAction(CustomerBaseApiActions.READ_DEFAULT_CUSTOMER_BASE_FAILURE);

export const setDefaultCustomerBase = createAction<string | undefined>(CustomerBaseApiActions.SET_DEFAULT_CUSTOMER_BASE);
export const setDefaultCustomerBaseSuccess = createAction(CustomerBaseApiActions.SET_DEFAULT_CUSTOMER_BASE_SUCCESS);
export const setDefaultCustomerBaseFailure = createAction(CustomerBaseApiActions.SET_DEFAULT_CUSTOMER_BASE_FAILURE);
